// components/Home.js
import React, { useState, useEffect, useRef } from 'react';
import httpClient from '../../Api/axios';

const Home = () => {
  // Add this useEffect to handle header spacing
  // useEffect(() => {
  //   // Calculate header height and set padding
  //   const updatePadding = () => {
  //     const header = document.querySelector('header');
  //     const homeContainer = document.getElementById('home-container');
  //     if (header && homeContainer) {
  //       const headerHeight = header.offsetHeight;
  //       homeContainer.style.paddingTop = `${headerHeight}px`;
  //     }
  //   };

  //   // Initial update
  //   updatePadding();

  //   // Update on window resize
  //   window.addEventListener('resize', updatePadding);
    
  //   // Update after a delay to ensure everything is loaded
  //   const timeoutId = setTimeout(updatePadding, 100);

  //   return () => {
  //     window.removeEventListener('resize', updatePadding);
  //     clearTimeout(timeoutId);
  //   };
  // }, []);

  // State for banners (now as array)
  const [banners, setBanners] = useState([]);
  const [bannerLoading, setBannerLoading] = useState(true);
  const [bannerError, setBannerError] = useState(null);
  const [currentBannerIndex, setCurrentBannerIndex] = useState(0);
  const bannerIntervalRef = useRef(null);
  
  // State for testimonials
  const [testimonials, setTestimonials] = useState([]);
  const [testimonialsLoading, setTestimonialsLoading] = useState(true);
  const [testimonialsError, setTestimonialsError] = useState(null);
  const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState(0);
  const testimonialIntervalRef = useRef(null);

  // Fetch banner data
  useEffect(() => {
    const fetchBanner = async () => {
      try {
        setBannerLoading(true);
        setBannerError(null);
        
        console.log('Fetching banner data...');
        const response = await httpClient.get('/getall__banner');
        console.log('Banner API Response:', response.data);
        
        // Handle different response structures
        let bannerData = response.data;
        
        // If response has a data property
        if (bannerData && bannerData.data) {
          bannerData = bannerData.data;
        }
        
        // Filter active banners
        if (Array.isArray(bannerData)) {
          const activeBanners = bannerData.filter(b => b.status === "active");
          setBanners(activeBanners);
          if (activeBanners.length === 0) {
            console.log('No active banners found');
          }
        } else if (bannerData && bannerData.status === "active") {
          // If it's a single object
          setBanners([bannerData]);
        } else {
          setBanners([]);
        }
      } catch (err) {
        console.error('Error fetching banner:', err);
        console.error('Error response:', err.response?.data);
        setBannerError(err.response?.data?.message || 'Failed to load banner');
      } finally {
        setBannerLoading(false);
      }
    };

    fetchBanner();
  }, []);

  // Banner slider auto-play
  useEffect(() => {
    if (banners.length > 1) {
      // Clear existing interval
      if (bannerIntervalRef.current) {
        clearInterval(bannerIntervalRef.current);
      }
      
      // Set new interval
      bannerIntervalRef.current = setInterval(() => {
        setCurrentBannerIndex(prevIndex => 
          prevIndex === banners.length - 1 ? 0 : prevIndex + 1
        );
      }, 3000);
      
      // Cleanup on unmount
      return () => {
        if (bannerIntervalRef.current) {
          clearInterval(bannerIntervalRef.current);
        }
      };
    }
  }, [banners]);

  // Fetch testimonials data
  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        setTestimonialsLoading(true);
        setTestimonialsError(null);
        
        console.log('Fetching testimonials data...');
        const response = await httpClient.get('/getall__testimonial');
        console.log('Testimonials API Response:', response.data);
        
        // Handle different response structures
        let testimonialsData = response.data;
        
        // If response has a data property
        if (testimonialsData && testimonialsData.data) {
          testimonialsData = testimonialsData.data;
        }
        
        // Filter only active testimonials
        if (Array.isArray(testimonialsData)) {
          const activeTestimonials = testimonialsData.filter(t => 
            t.status === "Active" || t.status === "active"
          );
          
          if (activeTestimonials.length > 0) {
            setTestimonials(activeTestimonials);
          } else {
            setTestimonials([]);
            console.log('No active testimonials found');
          }
        } else {
          setTestimonials([]);
        }
      } catch (err) {
        console.error('Error fetching testimonials:', err);
        console.error('Error response:', err.response?.data);
        setTestimonialsError(err.response?.data?.message || 'Failed to load testimonials');
      } finally {
        setTestimonialsLoading(false);
      }
    };

    fetchTestimonials();
  }, []);

  // Testimonial slider auto-play
  useEffect(() => {
    if (testimonials.length > 1) {
      // Clear existing interval
      if (testimonialIntervalRef.current) {
        clearInterval(testimonialIntervalRef.current);
      }
      
      // Set new interval
      testimonialIntervalRef.current = setInterval(() => {
        setCurrentTestimonialIndex(prevIndex => 
          prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
        );
      }, 3000);
      
      // Cleanup on unmount
      return () => {
        if (testimonialIntervalRef.current) {
          clearInterval(testimonialIntervalRef.current);
        }
      };
    }
  }, [testimonials]);

  // Function to handle banner navigation
  const goToBanner = (index) => {
    setCurrentBannerIndex(index);
    // Reset interval when manually navigating
    if (bannerIntervalRef.current) {
      clearInterval(bannerIntervalRef.current);
      bannerIntervalRef.current = setInterval(() => {
        setCurrentBannerIndex(prevIndex => 
          prevIndex === banners.length - 1 ? 0 : prevIndex + 1
        );
      }, 3000);
    }
  };

  // Function to handle testimonial navigation
  const goToTestimonial = (index) => {
    setCurrentTestimonialIndex(index);
    // Reset interval when manually navigating
    if (testimonialIntervalRef.current) {
      clearInterval(testimonialIntervalRef.current);
      testimonialIntervalRef.current = setInterval(() => {
        setCurrentTestimonialIndex(prevIndex => 
          prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
        );
      }, 3000);
    }
  };

  // Function to render star rating
  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
    
    for (let i = 1; i <= 5; i++) {
      if (i <= fullStars) {
        stars.push(
          <svg key={i} className="w-5 h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
          </svg>
        );
      } else if (hasHalfStar && i === fullStars + 1) {
        stars.push(
          <svg key={i} className="w-5 h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
            <defs>
              <linearGradient id="half">
                <stop offset="50%" stopColor="currentColor" />
                <stop offset="50%" stopColor="#E5E7EB" />
              </linearGradient>
            </defs>
            <path fill="url(#half)" d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
          </svg>
        );
      } else {
        stars.push(
          <svg key={i} className="w-5 h-5 text-gray-300" fill="currentColor" viewBox="0 0 20 20">
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
          </svg>
        );
      }
    }
    return stars;
  };

  return (
    <div style={{
      paddingTop:'0px'
    }} id="home-container" className="min-h-screen bg-white overflow-x-hidden">

      {/* ===== TOP BANNER SLIDER SECTION ===== */}
   {/* ===== TOP BANNER SLIDER SECTION ===== */}
{/* ===== TOP BANNER SLIDER SECTION ===== */}
{bannerLoading ? (
  <div className="h-[250px] md:h-[350px] lg:h-[500px] bg-gradient-to-r from-gray-200 to-gray-300 animate-pulse flex items-center justify-center">
    <div className="text-gray-500">Loading banner...</div>
  </div>
) : bannerError ? (
  <div className="h-10 bg-red-100 text-red-600 text-center py-2 text-sm">
    {bannerError}
  </div>
) : banners.length > 0 ? (
  <div className="relative w-full overflow-hidden">
    {/* Banner Container with responsive height */}
    <div className="relative h-[250px] md:h-[350px] lg:h-[500px]"> {/* Responsive height container */}
      <div 
        className="flex transition-transform duration-500 ease-in-out h-full"
        style={{ transform: `translateX(-${currentBannerIndex * 100}%)` }}
      >
        {banners.map((banner, index) => (
          <div 
            key={banner._id || index}
            className="w-full flex-shrink-0 relative h-full"
          >
            {/* Banner Image with responsive object-cover */}
            <div className="relative w-full h-full">
              <img 
                src={banner.image} 
                alt={`Banner ${index + 1}`}
                className="w-full h-full object-cover object-center"
                loading={index === 0 ? "eager" : "lazy"}
                onError={(e) => {
                  console.error('Failed to load banner image:', banner.image);
                  // Show fallback if image fails to load
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = `
                    <div class="w-full h-full bg-gradient-to-r from-red-600 via-blue-600 to-green-600 flex items-center justify-center">
                      <div class="text-white text-lg md:text-2xl font-bold">Banner ${index + 1}</div>
                    </div>
                  `;
                }}
              />
              {/* Optional overlay or text content - responsive opacity */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent md:from-black/20 md:to-transparent"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
    
    {/* Banner Navigation Dots - Responsive positioning and size */}
    {banners.length > 1 && (
      <div className="absolute bottom-4 md:bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-2 md:space-x-3 z-10">
        {banners.map((_, index) => (
          <button
            key={index}
            onClick={() => goToBanner(index)}
            className={`w-2 h-2 md:w-3 md:h-3 rounded-full transition-all duration-300 ${
              index === currentBannerIndex 
                ? 'bg-white scale-125' 
                : 'bg-white/50 hover:bg-white/80'
            }`}
            aria-label={`Go to banner ${index + 1}`}
          />
        ))}
      </div>
    )}
    
    {/* Banner Navigation Arrows - Responsive size and positioning */}
    {banners.length > 1 && (
      <>
        <button
          onClick={() => goToBanner(currentBannerIndex === 0 ? banners.length - 1 : currentBannerIndex - 1)}
          className="absolute left-2 md:left-4 top-1/2 transform -translate-y-1/2 bg-black/40 hover:bg-black/60 text-white p-2 md:p-3 rounded-full transition-all duration-300 z-10 backdrop-blur-sm"
          aria-label="Previous banner"
        >
          <svg className="w-4 h-4 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <button
          onClick={() => goToBanner(currentBannerIndex === banners.length - 1 ? 0 : currentBannerIndex + 1)}
          className="absolute right-2 md:right-4 top-1/2 transform -translate-y-1/2 bg-black/40 hover:bg-black/60 text-white p-2 md:p-3 rounded-full transition-all duration-300 z-10 backdrop-blur-sm"
          aria-label="Next banner"
        >
          <svg className="w-4 h-4 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </>
    )}
  </div>
) : (
  // Fallback when no banners - responsive height
  <div className="h-[250px] md:h-[350px] lg:h-[500px] bg-gradient-to-r from-red-600 via-blue-600 to-green-600 flex items-center justify-center">
    <div className="text-white text-lg md:text-2xl font-bold">No banners available</div>
  </div>
)}

      <main id="main-content">
        
        {/* ===== 1. HERO SECTION ===== */}
<section className="relative overflow-hidden bg-gradient-to-b from-gray-50 to-white pt-8 md:pt-12 pb-20 md:pb-32">
          {/* Background pattern */}
          <div className="absolute inset-0 opacity-5">
            <div className="absolute inset-0" style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%239C92AC' fill-opacity='0.1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
            }}></div>
          </div>
          
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl relative z-10">
            <div className="text-center">
             
             

              {/* Main headline */}
              <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight mb-6">
                <span className="block text-gray-900">Human-Led Technology</span>
                <span className="block mt-2 text-transparent bg-clip-text bg-gradient-to-r from-red-600 via-gray-800 to-blue-600">
                  North American Accountability
                </span>
                <span className="block mt-2 text-gray-900">Indian Execution Excellence</span>
              </h1>

              {/* Sub-headline */}
              <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto mb-10 leading-relaxed">
                Real people. Clear ownership. End-to-end IT consulting and delivery for US & Canadian businesses.
              </p>

              {/* CTA buttons */}
              <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
                <a
                  href="/book-call"
                  className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-red-600 to-red-700 text-white px-8 py-4 rounded-lg font-semibold text-lg shadow-lg hover:shadow-xl hover:scale-[1.02] transition-all duration-300 group"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                  </svg>
                  Book a Strategy Call
                  <svg className="w-5 h-5 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                  </svg>
                </a>
                
                <a
                  href="/contact"
                  className="inline-flex items-center justify-center gap-2 bg-white text-gray-900 border-2 border-gray-300 px-8 py-4 rounded-lg font-semibold text-lg shadow-sm hover:shadow-md hover:border-red-300 transition-all duration-300 group"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                  </svg>
                  Talk to a Human (Not a Bot)
                </a>
              </div>

             
            </div>
          </div>
        </section>

        {/* ===== 2. THE PROBLEM WE SOLVE ===== */}
        <section className="py-20 bg-gray-900 text-white">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
            <div className="text-center mb-16">
            
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
                The IT Industry Has a <span className="text-red-400">Responsibility</span> Problem
              </h2>
              <p className="text-xl text-gray-300 max-w-3xl mx-auto">
                Technology fails when responsibility is outsourced to faceless teams and automated responses.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {[
                {
                  icon: (
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
                    </svg>
                  ),
                  title: "Anonymous vendors, no ownership",
                  color: "text-red-500",
                  description: "No single point of contact, endless support tickets"
                },
                {
                  icon: (
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                    </svg>
                  ),
                  title: "AI tools but no accountability",
                  color: "text-blue-500",
                  description: "Automated responses without human understanding"
                },
                {
                  icon: (
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.998-.833-2.732 0L4.138 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
                    </svg>
                  ),
                  title: "Offshore teams with zero business context",
                  color: "text-amber-500",
                  description: "Cultural and timezone gaps causing misalignment"
                },
                {
                  icon: (
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                    </svg>
                  ),
                  title: "Projects delivered, but problems remain",
                  color: "text-purple-500",
                  description: "Solutions that don't solve real business problems"
                }
              ].map((point, index) => (
                <div
                  key={index}
                  className="bg-gray-800/50 border border-gray-700 rounded-xl p-6 hover:border-red-500/50 transition-all duration-300 hover:transform hover:-translate-y-1"
                >
                  <div className={`${point.color} mb-4`}>
                    {point.icon}
                  </div>
                  <h3 className="text-lg font-semibold mb-2">{point.title}</h3>
                  <p className="text-gray-400 text-sm">{point.description}</p>
                </div>
              ))}
            </div>

            <div className="mt-16 text-center p-8 bg-gradient-to-r from-red-900/30 to-blue-900/30 rounded-2xl border border-gray-700">
              <p className="text-2xl font-bold italic">
                "Technology without ownership is just another expense."
              </p>
            </div>
          </div>
        </section>

        {/* ===== 3. THE KANDAX DIFFERENCE ===== */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
            <div className="text-center mb-16">
             
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                What Makes <span className="text-red-600">KANDAX</span> Different
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
              {[
                {
                  icon: "🧠",
                  title: "Human-Led Engagement",
                  description: "Named account owner. Direct access. Real conversations.",
                  color: "from-purple-500 to-pink-500",
                  features: [
                    "Dedicated account executive",
                    "Direct Slack/Teams access",
                    "Weekly strategic reviews",
                    "Executive escalation path"
                  ]
                },
                {
                  icon: "🇨🇦",
                  title: "North American Accountability",
                  description: "Strategy, compliance, and ownership stay in Canada.",
                  color: "from-red-500 to-red-600",
                  features: [
                    "Canadian legal entity",
                    "GDPR/PIPEDA compliance",
                    "In-country data sovereignty",
                    "Local contract enforcement"
                  ]
                },
                {
                  icon: "🇮🇳",
                  title: "Indian Execution Excellence",
                  description: "Senior engineers, structured delivery, long-term teams.",
                  color: "from-green-500 to-emerald-600",
                  features: [
                    "10+ years average experience",
                    "<5% annual attrition",
                    "Domain-specific training",
                    "Career growth paths"
                  ]
                }
              ].map((pillar, index) => (
                <div key={index} className="relative group">
                  <div className="absolute inset-0 bg-gradient-to-r opacity-0 group-hover:opacity-10 transition-opacity duration-300 rounded-2xl"
                    style={{ background: `linear-gradient(to right, var(--tw-gradient-stops))` }}
                  ></div>
                  
                  <div className="relative bg-white border-2 border-gray-100 rounded-2xl p-8 h-full shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
                    <div className={`inline-flex items-center justify-center p-4 rounded-xl bg-gradient-to-r ${pillar.color} mb-6`}>
                      <span className="text-2xl">{pillar.icon}</span>
                    </div>
                    
                    <h3 className="text-xl font-bold text-gray-900 mb-4">{pillar.title}</h3>
                    <p className="text-gray-600 mb-6">{pillar.description}</p>
                    
                    <ul className="space-y-2">
                      {pillar.features.map((item, i) => (
                        <li key={i} className="flex items-center gap-2 text-sm text-gray-600">
                          <svg className="w-4 h-4 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                          </svg>
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>

            <div className="text-center p-8 bg-gradient-to-r from-gray-50 to-blue-50 rounded-2xl border border-gray-200">
              <p className="text-2xl font-bold text-gray-900">
                We don't outsource responsibility. We <span className="text-red-600">own outcomes</span>.
              </p>
            </div>
          </div>
        </section>

        {/* ===== 4. WHAT WE DO (SERVICES) - UPDATED ===== */}
        <section className="py-20 bg-gray-50">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
            <div className="text-center mb-16">
              
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                Focused Services. <span className="text-red-600">Clear Outcomes</span>.
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                End-to-end technology solutions with measurable business impact
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
              {[
                {
                  icon: "🌐",
                  title: "Web Development",
                  description: "Custom web applications and responsive websites built with modern technologies.",
                  features: ["Full-stack development", "E-commerce solutions", "CMS integration"],
                  color: "bg-gradient-to-br from-blue-500 to-cyan-500"
                },
                {
                  icon: "📈",
                  title: "Digital Marketing",
                  description: "Data-driven marketing strategies to grow your online presence and revenue.",
                  features: ["SEO & SEM", "Social media marketing", "Content strategy"],
                  color: "bg-gradient-to-br from-purple-500 to-pink-500"
                },
                {
                  icon: "🔒",
                  title: "Cybersecurity",
                  description: "Protect your business with advanced security solutions and compliance management.",
                  features: ["Security audits", "Threat detection", "Compliance management"],
                  color: "bg-gradient-to-br from-red-500 to-orange-500"
                },
                {
                  icon: "🤖",
                  title: "AI Adoption & Business Automation",
                  description: "AI that actually works inside your business—not just demos.",
                  features: ["Custom LLM integration", "Process automation", "Data pipeline optimization"],
                  color: "bg-gradient-to-br from-green-500 to-emerald-500"
                }
              ].map((service, index) => (
                <div
                  key={index}
                  className="bg-white rounded-2xl p-8 border border-gray-200 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 group"
                >
                  <div className={`${service.color} inline-flex items-center justify-center p-4 rounded-xl mb-6 text-2xl`}>
                    {service.icon}
                  </div>
                  
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                  <p className="text-gray-600 mb-6">{service.description}</p>
                  
                  <ul className="space-y-3 mb-8">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center gap-3 text-gray-700">
                        <div className="w-2 h-2 rounded-full bg-red-500"></div>
                        {feature}
                      </li>
                    ))}
                  </ul>
                  
                 
                </div>
              ))}
            </div>

            
          </div>
        </section>

        {/* ===== 5. WHO WE SERVE ===== */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
            <div className="text-center mb-16">
              
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                Built for Businesses That <span className="text-red-600">Value Ownership</span>
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
              {[
                { name: "SMBs & Mid-Market", desc: "Growing companies needing scalable solutions", icon: "🏢" },
                { name: "Funded Startups", desc: "Founders requiring strategic tech leadership", icon: "🚀" },
                { name: "Healthcare", desc: "HIPAA-compliant systems and patient data security", icon: "🏥" },
                { name: "Professional Services", desc: "Legal, accounting, and consulting firms", icon: "⚖️" },
                { name: "Manufacturing", desc: "Operational technology and supply chain systems", icon: "🏭" },
                { name: "FinTech", desc: "Secure, compliant financial technology", icon: "💰" },
                { name: "E-commerce", desc: "Scalable platforms with seamless UX", icon: "🛒" },
                { name: "Enterprises", desc: "Legacy modernization and digital transformation", icon: "🏛️" }
              ].map((industry, index) => (
                <div key={index} className="bg-gray-50 border border-gray-200 rounded-xl p-6 text-center hover:border-red-300 hover:shadow-lg transition-all">
                  <div className="text-3xl mb-4">{industry.icon}</div>
                  <h3 className="font-bold text-gray-900 mb-2">{industry.name}</h3>
                  <p className="text-sm text-gray-600">{industry.desc}</p>
                </div>
              ))}
            </div>

            <div className="text-center p-8 bg-gradient-to-r from-gray-50 to-red-50 rounded-2xl border border-gray-200">
              <p className="text-2xl font-bold text-gray-900">
                If <span className="text-red-600">accountability matters</span>, KANDAX fits.
              </p>
            </div>
          </div>
        </section>

        {/* ===== 6. HOW WE WORK (PROCESS) ===== */}
        <section className="py-20 bg-gray-900 text-white">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
            <div className="text-center mb-16">
             
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
                A Human-Centered <span className="text-red-400">Delivery Process</span>
              </h2>
              <p className="text-xl text-gray-300 max-w-3xl mx-auto">
                Transparent, collaborative, and designed for long-term success
              </p>
            </div>

            <div className="relative">
              {/* Connecting line for desktop */}
              <div className="hidden md:block absolute top-16 left-0 right-0 h-0.5 bg-gradient-to-r from-blue-500 via-purple-500 via-red-500 to-green-500 z-0"></div>
              
              <div className="grid grid-cols-1 md:grid-cols-4 gap-8 relative z-10">
                {[
                  {
                    number: "01",
                    icon: "🔍",
                    title: "Discover",
                    subtitle: "Business-first understanding",
                    description: "We start by understanding your business goals, challenges, and constraints before discussing technology.",
                    color: "from-blue-500 to-cyan-500"
                  },
                  {
                    number: "02",
                    icon: "🎨",
                    title: "Design",
                    subtitle: "Strategy before code",
                    description: "Architectural design, technology selection, and project planning with clear milestones and deliverables.",
                    color: "from-purple-500 to-pink-500"
                  },
                  {
                    number: "03",
                    icon: "⚡",
                    title: "Deliver",
                    subtitle: "India-led execution, Canada-led oversight",
                    description: "Agile development with weekly demos, continuous integration, and transparent progress tracking.",
                    color: "from-red-500 to-orange-500"
                  },
                  {
                    number: "04",
                    icon: "🤝",
                    title: "Support",
                    subtitle: "Long-term partnership, not handoff",
                    description: "Ongoing maintenance, updates, and evolution of your solution with dedicated support teams.",
                    color: "from-green-500 to-emerald-500"
                  }
                ].map((step, index) => (
                  <div key={index} className="text-center">
                    <div className={`mb-6 inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-r ${step.color} text-white font-bold text-2xl shadow-lg`}>
                      {step.number}
                    </div>
                    
                    {/* <div className="bg-gray-800 border-2 border-gray-700 rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300"> */}
                    <div className="bg-gray-800 border-2 border-gray-700 rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300
                min-h-[340px] flex flex-col items-center">

                      <div className={`inline-flex items-center justify-center p-3 rounded-xl bg-gradient-to-r ${step.color} mb-4 text-2xl`}>
                        {step.icon}
                      </div>
                      
                      <h3 className="text-xl font-bold mb-2">{step.title}</h3>
                      <p className="text-gray-300 font-medium mb-4">{step.subtitle}</p>
                      <p className="text-gray-400 text-sm">{step.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

       
          </div>
        </section>

        {/* ===== 7. TRUST & CREDIBILITY ===== */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
            <div className="text-center mb-16">
             
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                Why Clients <span className="text-red-600">Choose KANDAX</span>
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
              {[
                {
                  title: "Canadian Leadership & Governance",
                  description: "All strategic decisions made in Canada with local accountability",
                  icon: "🇨🇦"
                },
                {
                  title: "Senior Engineering Teams",
                  description: "No junior engineers. Average 10+ years experience per developer",
                  icon: "👨‍💻"
                },
                {
                  title: "Clear SLAs & Communication",
                  description: "Guaranteed response times and regular executive reviews",
                  icon: "📋"
                },
                {
                  title: "Long-Term Partnerships",
                  description: "We grow with you, not just complete projects",
                  icon: "🤝"
                }
              ].map((item, index) => (
                <div key={index} className="text-center p-6">
                  <div className="text-4xl mb-4">{item.icon}</div>
                  <h3 className="font-bold text-gray-900 text-lg mb-3">{item.title}</h3>
                  <p className="text-gray-600">{item.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ===== 8. INDIA DELIVERY STORY ===== */}
        <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
              
                <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                  Our India <span className="text-red-600">Center of Excellence</span>
                </h2>
                <p className="text-xl text-gray-600 mb-8">
                  India is not a cost center for us—it's our execution backbone. Our teams are domain-trained, stable, and deeply integrated with our Canadian leadership.
                </p>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {[
                    { label: "Senior engineers", value: "10+ years avg." },
                    { label: "Team attrition", value: "< 5%" },
                    { label: "Domain training", value: "Ongoing" },
                    { label: "Security certified", value: "100%" }
                  ].map((stat, index) => (
                    <div key={index} className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm">
                      <div className="text-2xl font-bold text-red-600 mb-1">{stat.value}</div>
                      <div className="text-gray-700">{stat.label}</div>
                    </div>
                  ))}
                </div>
              </div>
              
              <div className="bg-white rounded-2xl p-8 shadow-xl border border-gray-200">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">Execution Excellence</h3>
                <ul className="space-y-4">
                  {[
                    "Stable, long-term engineering teams",
                    "Deep domain expertise across industries",
                    "Secure development processes (ISO 27001)",
                    "Continuous training & certification programs",
                    "Seamless integration with Canadian leadership",
                    "Follow-the-sun delivery model"
                  ].map((item, index) => (
                    <li key={index} className="flex items-start gap-3">
                      <svg className="w-5 h-5 text-red-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      <span className="text-gray-700">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* ===== 9. TESTIMONIALS SLIDER SECTION ===== */}
        {(testimonialsLoading || testimonials.length > 0 || testimonialsError) && (
          <section className="py-20 bg-gray-50">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
              <div className="text-center mb-16">
              
                <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                  What Our <span className="text-red-600">Clients Say</span>
                </h2>
                <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                  Hear from businesses that have experienced the KANDAX difference
                </p>
              </div>

              {testimonialsLoading ? (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                  {[1, 2, 3].map((item) => (
                    <div key={item} className="bg-white rounded-2xl p-8 border border-gray-200 animate-pulse">
                      <div className="flex items-center mb-6">
                        <div className="w-16 h-16 rounded-full bg-gray-300"></div>
                        <div className="ml-4">
                          <div className="h-4 bg-gray-300 rounded w-32 mb-2"></div>
                          <div className="h-3 bg-gray-300 rounded w-24"></div>
                        </div>
                      </div>
                      <div className="h-4 bg-gray-300 rounded mb-2"></div>
                      <div className="h-4 bg-gray-300 rounded mb-2"></div>
                      <div className="h-4 bg-gray-300 rounded w-3/4"></div>
                    </div>
                  ))}
                </div>
              ) : testimonialsError ? (
                <div className="text-center py-8">
                  <div className="inline-flex items-center gap-2 text-red-600">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                    <p>{testimonialsError}</p>
                  </div>
                </div>
              ) : testimonials.length > 0 ? (
                <div className="relative">
                  {/* Testimonial Container */}
                  <div 
                    className="flex transition-transform duration-500 ease-in-out"
                    style={{ transform: `translateX(-${currentTestimonialIndex * 100}%)` }}
                  >
                    {testimonials.map((testimonial, index) => (
                      <div 
                        key={testimonial._id || index}
                        className="w-full flex-shrink-0 px-4"
                      >
                        <div className="bg-white rounded-2xl p-6 md:p-8 border border-gray-200 shadow-lg hover:shadow-xl transition-all duration-300 max-w-4xl mx-auto">
                          <div className="flex flex-col md:flex-row items-center mb-6">
                            <img
                              src={testimonial.client_image}
                              alt={testimonial.client_name}
                              className="w-20 h-20 md:w-24 md:h-24 rounded-full object-cover border-4 border-red-100 mb-4 md:mb-0 md:mr-6"
                              onError={(e) => {
                                e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(testimonial.client_name)}&background=ff4444&color=fff&size=128`;
                              }}
                            />
                            <div className="text-center md:text-left">
                              <h3 className="text-xl font-bold text-gray-900">{testimonial.client_name}</h3>
                              <p className="text-gray-600">{testimonial.client_designation}</p>
                              <div className="flex justify-center md:justify-start mt-2">
                                {renderStars(testimonial.rating || 5)}
                                <span className="ml-2 text-sm font-medium text-gray-900">
                                  {testimonial.rating || 5}/5
                                </span>
                              </div>
                            </div>
                          </div>
                          
                          <p className="text-gray-700 italic text-lg md:text-xl text-center md:text-left mb-6">
                            "{testimonial.testimonial_text || "Great service and support!"}"
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                  
                  {/* Testimonial Navigation Dots - Only show if more than 1 testimonial */}
                  {testimonials.length > 1 && (
                    <div className="flex justify-center mt-8 space-x-2">
                      {testimonials.map((_, index) => (
                        <button
                          key={index}
                          onClick={() => goToTestimonial(index)}
                          className={`w-3 h-3 rounded-full transition-all duration-300 ${
                            index === currentTestimonialIndex 
                              ? 'bg-red-600 scale-125' 
                              : 'bg-gray-300 hover:bg-gray-400'
                          }`}
                          aria-label={`Go to testimonial ${index + 1}`}
                        />
                      ))}
                    </div>
                  )}
                  
                  {/* Testimonial Navigation Arrows - Only show if more than 1 testimonial */}
                  {testimonials.length > 1 && (
                    <>
                      <button
                        onClick={() => goToTestimonial(currentTestimonialIndex === 0 ? testimonials.length - 1 : currentTestimonialIndex - 1)}
                        className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-white shadow-lg hover:bg-gray-50 text-gray-800 p-3 rounded-full transition-all duration-300 z-10 hidden md:block"
                        aria-label="Previous testimonial"
                      >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
                        </svg>
                      </button>
                      <button
                        onClick={() => goToTestimonial(currentTestimonialIndex === testimonials.length - 1 ? 0 : currentTestimonialIndex + 1)}
                        className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-white shadow-lg hover:bg-gray-50 text-gray-800 p-3 rounded-full transition-all duration-300 z-10 hidden md:block"
                        aria-label="Next testimonial"
                      >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                        </svg>
                      </button>
                    </>
                  )}
                </div>
              ) : (
                <div className="text-center py-8">
                  <div className="inline-flex items-center gap-2 text-gray-500">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"></path>
                    </svg>
                    <p>No testimonials available yet</p>
                  </div>
                </div>
              )}
            </div>
          </section>
        )}

        {/* ===== 10. FINAL CTA ===== */}
        <section className="py-20 bg-gradient-to-br from-gray-900 to-black text-white">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl text-center">
            
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
              Technology Is Everywhere. <span className="text-red-400">Ownership Is Rare</span>.
            </h2>
            <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto">
              Partner with a team that stays accountable from start to scale.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/book-call"
                className="inline-flex items-center justify-center gap-3 bg-gradient-to-r from-red-600 to-red-700 text-white px-10 py-5 rounded-xl font-semibold text-lg shadow-2xl hover:shadow-red-500/30 hover:scale-[1.02] transition-all duration-300 group"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                </svg>
                Book Your Strategy Call
                <svg className="w-5 h-5 transform group-hover:translate-x-2 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                </svg>
              </a>
              
              <a
                href="/contact"
                className="inline-flex items-center justify-center gap-3 bg-transparent text-white border-2 border-gray-700 px-10 py-5 rounded-xl font-semibold text-lg hover:border-red-500 hover:bg-red-500/10 transition-all duration-300"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                </svg>
                Speak With a Human Today
              </a>
            </div>
            
            <p className="mt-10 text-gray-400">
              No bots. No runaround. Just real conversations with accountable partners.
            </p>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Home;